module.exports = __webpack_public_path__ + "img/icon-nut.4c1a682f.svg";